<div class="outer">
  <div class="inner">
    @if (imageSrc) {
      <img src="{{imageSrc}}" alt="">
    }
    @if (header) {
      <div class="text-heading">{{ header }}</div>
    }
    <div class="text-subtitle">
      <ng-content></ng-content>
    </div>

    <ng-content select="[button]"></ng-content>
  </div>
</div>
